import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';
import _ from 'lodash';
/**
 * This reducer function handles all the actions related to the top-level objects.
 * @param {Object} state - A portion of the overall Redux state, specifically the
 *      store.<%=names.camel%> object, representing the current data.
 * @param {Object} action - Action object containing type and other values
 * @return {*} current state or array of language objects
 */
export default function taskWorkspaceEngagementsReducer(
	state = initialState.engagementMembers,
	action
) {
	switch (action.type) {
		case types.GET_ENGAGEMENT_MEMBERS: {
			let engagementMembers = action.response;
			return _.cloneDeep(engagementMembers);
		}
		case types.CLEAR_ENGAGEMENT_MEMBERS:
			return null;
		default:
			return state;
	}
}
